module.exports = __webpack_public_path__ + "img/send_deal_data.22c968c3.jpg";